var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _g4, _g5, _path7, _rect, _g6, _g7, _path8, _path9, _g8, _path10, _g9, _path11, _path12, _g10, _path13, _g11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 32,
    viewBox: "0 0 153 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_617_31558)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17178 23.5009C5.23545 23.3289 5.47883 23.3289 5.5425 23.5009V23.5009C6.34324 25.6649 8.04939 27.371 10.2134 28.1718V28.1718C10.3854 28.2355 10.3854 28.4788 10.2134 28.5425V28.5425C8.04939 29.3432 6.34324 31.0494 5.5425 33.2134V33.2134C5.47883 33.3854 5.23545 33.3854 5.17178 33.2134V33.2134C4.37104 31.0494 2.66489 29.3432 0.50093 28.5425V28.5425C0.328858 28.4788 0.328858 28.2355 0.500931 28.1718V28.1718C2.66489 27.371 4.37104 25.6649 5.17178 23.5009V23.5009Z",
    fill: "#EFAB0C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_617_31558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 23,
    width: 11,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17178 23.5009C5.23545 23.3289 5.47883 23.3289 5.5425 23.5009V23.5009C6.34324 25.6649 8.04939 27.371 10.2134 28.1718V28.1718C10.3854 28.2355 10.3854 28.4788 10.2134 28.5425V28.5425C8.04939 29.3432 6.34324 31.0494 5.5425 33.2134V33.2134C5.47883 33.3854 5.23545 33.3854 5.17178 33.2134V33.2134C4.37104 31.0494 2.66489 29.3432 0.50093 28.5425V28.5425C0.328858 28.4788 0.328858 28.2355 0.500931 28.1718V28.1718C2.66489 27.371 4.37104 25.6649 5.17178 23.5009V23.5009Z",
    fill: "#FEE699"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_617_31558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7148 28.3577C8.92913 28.3577 5.3577 30.1434 5.3577 33.7148L10.7148 28.3577Z",
    fill: "#EFAB0C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_617_31558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 23,
    width: 11,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17178 23.5009C5.23545 23.3289 5.47883 23.3289 5.5425 23.5009V23.5009C6.34324 25.6649 8.04939 27.371 10.2134 28.1718V28.1718C10.3854 28.2355 10.3854 28.4788 10.2134 28.5425V28.5425C8.04939 29.3432 6.34324 31.0494 5.5425 33.2134V33.2134C5.47883 33.3854 5.23545 33.3854 5.17178 33.2134V33.2134C4.37104 31.0494 2.66489 29.3432 0.50093 28.5425V28.5425C0.328858 28.4788 0.328858 28.2355 0.500931 28.1718V28.1718C2.66489 27.371 4.37104 25.6649 5.17178 23.5009V23.5009Z",
    fill: "#FEE699"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_617_31558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 28.3571C1.78571 28.3571 5.35714 26.5714 5.35714 23L0 28.3571Z",
    fill: "#EFAB0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7148 28.3571C8.92913 28.3571 5.3577 26.5714 5.3577 23L10.7148 28.3571Z",
    fill: "#EFAB0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 28.3577C1.78571 28.3577 5.35714 30.1434 5.35714 33.7148L0 28.3577Z",
    fill: "#EFAB0C"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7186 1.00186C15.8459 0.657716 16.3327 0.657716 16.46 1.00186V1.00186C18.0615 5.32978 21.4738 8.74209 25.8017 10.3436V10.3436C26.1459 10.4709 26.1459 10.9577 25.8017 11.085V11.085C21.4738 12.6865 18.0615 16.0988 16.46 20.4267V20.4267C16.3327 20.7709 15.8459 20.7709 15.7186 20.4267V20.4267C14.1171 16.0988 10.7048 12.6865 6.37686 11.085V11.085C6.03272 10.9577 6.03272 10.4709 6.37686 10.3436V10.3436C10.7048 8.74209 14.1171 5.32978 15.7186 1.00186V1.00186Z",
    fill: "#EFAB0C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_617_31558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 21,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7186 1.00186C15.8459 0.657716 16.3327 0.657716 16.46 1.00186V1.00186C18.0615 5.32978 21.4738 8.74209 25.8017 10.3436V10.3436C26.1459 10.4709 26.1459 10.9577 25.8017 11.085V11.085C21.4738 12.6865 18.0615 16.0988 16.46 20.4267V20.4267C16.3327 20.7709 15.8459 20.7709 15.7186 20.4267V20.4267C14.1171 16.0988 10.7048 12.6865 6.37686 11.085V11.085C6.03272 10.9577 6.03272 10.4709 6.37686 10.3436V10.3436C10.7048 8.74209 14.1171 5.32978 15.7186 1.00186V1.00186Z",
    fill: "#FEE699"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_617_31558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8047 10.7154C23.2333 10.7154 16.0904 14.2868 16.0904 21.4297L26.8047 10.7154Z",
    fill: "#EFAB0C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_617_31558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 21,
    height: 21
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7186 1.00186C15.8459 0.657716 16.3327 0.657716 16.46 1.00186V1.00186C18.0615 5.32978 21.4738 8.74209 25.8017 10.3436V10.3436C26.1459 10.4709 26.1459 10.9577 25.8017 11.085V11.085C21.4738 12.6865 18.0615 16.0988 16.46 20.4267V20.4267C16.3327 20.7709 15.8459 20.7709 15.7186 20.4267V20.4267C14.1171 16.0988 10.7048 12.6865 6.37686 11.085V11.085C6.03272 10.9577 6.03272 10.4709 6.37686 10.3436V10.3436C10.7048 8.74209 14.1171 5.32978 15.7186 1.00186V1.00186Z",
    fill: "#FEE699"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_617_31558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.375 10.7143C8.94643 10.7143 16.0893 7.14286 16.0893 0L5.375 10.7143Z",
    fill: "#EFAB0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8047 10.7143C23.2333 10.7143 16.0904 7.14286 16.0904 0L26.8047 10.7143Z",
    fill: "#EFAB0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.375 10.7154C8.94643 10.7154 16.0893 14.2868 16.0893 21.4297L5.375 10.7154Z",
    fill: "#EFAB0C"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_617_31558)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 47,
    width: 122,
    height: 98,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.25,
    y: 47.25,
    width: 121.5,
    height: 97.5,
    rx: 5.75,
    stroke: "#EBEDF5",
    strokeWidth: 0.5
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.016 118.176C123.653 118.548 123.058 118.556 122.685 118.194L120.656 116.22L120.656 124.059C120.656 124.579 120.235 125 119.715 125C119.195 125 118.774 124.579 118.774 124.059L118.774 116.161L116.75 118.185C116.382 118.552 115.786 118.552 115.419 118.185C115.052 117.818 115.052 117.222 115.419 116.854L118.998 113.276C119.362 112.912 119.95 112.908 120.319 113.267L123.997 116.845C124.37 117.208 124.378 117.803 124.016 118.176Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_617_31558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 47,
    width: 122,
    height: 98
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.25,
    y: 47.25,
    width: 121.5,
    height: 97.5,
    rx: 5.75,
    fill: "white",
    stroke: "#EBEDF5",
    strokeWidth: 0.5
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_617_31558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6022 157.037C55.8349 150.647 53.1976 134.687 56.7865 121.963C57.6022 120.332 58.4178 106.465 57.6022 101.571C56.9496 97.6561 55.9704 93.9583 55.5624 92.5989C56.7865 88.5197 62.9034 87.7046 65.3504 92.5989C69.8366 101.571 66.5739 114.214 77.5854 114.214C78.6208 114.213 81.4552 113.548 84.8216 110.95C84.9925 106.328 83.4709 97.0312 82.8873 93.8212C82.0716 89.335 86.0713 86.4801 88.3537 89.335C88.3299 88.244 88.2773 87.2738 88.1892 86.4802C87.7813 82.8096 92.2675 80.3626 95.1917 83.2175C96.0971 79.0207 102.53 77.3012 104.636 83.6255C105.319 83.0323 105.958 82.6106 106.542 82.402C112.251 80.3629 113.067 86.4804 112.251 87.7039C111.436 88.9274 108.173 96.6762 96.7537 112.99C85.3343 129.303 84.1108 142.354 88.597 152.142C86.9656 154.589 68.2065 159.485 57.6022 157.037Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7714 104.833C91.0113 100.891 94.1436 91.456 95.1223 83.6255C95.1396 83.4871 95.1629 83.351 95.1917 83.2175M89.7714 104.833C94.308 97.9629 100.326 87.3733 104.636 83.6255M89.7714 104.833C88.9117 106.135 88.1051 107.303 87.3735 108.266M104.636 83.6255C105.319 83.0323 105.958 82.6106 106.542 82.402C112.251 80.3629 113.067 86.4804 112.251 87.7039C111.436 88.9274 108.173 96.6762 96.7537 112.99C85.3343 129.303 84.1108 142.354 88.597 152.142C86.9656 154.589 68.2065 159.485 57.6022 157.037C55.8349 150.647 53.1976 134.687 56.7865 121.963C57.6022 120.332 58.4178 106.465 57.6022 101.571C56.9496 97.6561 55.9704 93.9583 55.5624 92.5989C56.7865 88.5197 62.9034 87.7046 65.3504 92.5989C69.8366 101.571 66.5739 114.214 77.5854 114.214C78.6208 114.213 81.4552 113.548 84.8216 110.95M104.636 83.6255C102.53 77.3012 96.0971 79.0207 95.1917 83.2175M87.3735 108.266C86.6019 109.282 85.9137 110.069 85.3343 110.543C85.1622 110.684 84.9912 110.819 84.8216 110.95M87.3735 108.266C87.8293 103.888 88.4772 94.9894 88.3537 89.335M95.1917 83.2175C92.2675 80.3626 87.7813 82.8096 88.1892 86.4802C88.2773 87.2738 88.3299 88.244 88.3537 89.335M84.8216 110.95C84.9925 106.328 83.4709 97.0312 82.8873 93.8212C82.0716 89.335 86.0713 86.4801 88.3537 89.335",
    stroke: "#4F46E5"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_617_31558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.297 88.168L26.999 24.1568L61.9042 24.1568L96.8094 24.1568L131.594 24.1568L79.297 88.168Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.272 0.00174442L26.999 24.1568L61.9042 24.1568L44.272 0.00174442Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.297 0.00173827L44.272 0.00174442L61.9042 24.1568L79.297 0.00173827Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8094 24.1568L79.297 0.00173827L61.9042 24.1568L96.8094 24.1568Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8094 24.1568L114.926 0.00174138L79.297 0.00173827L96.8094 24.1568Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.594 24.1568L114.926 0.00174138L96.8094 24.1568L131.594 24.1568Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4605 0.605621L78.118 0.605617L61.9009 23.128L45.4605 0.605621ZM44.2771 1.03288L60.7158 23.5529L28.1732 23.5529L44.2771 1.03288ZM28.2722 24.7607L61.4425 24.7607L77.9708 85.5903L28.2722 24.7607ZM79.299 85.8723L62.6941 24.7607L96.0181 24.7607L79.299 85.8723ZM80.6308 85.5809L97.2703 24.7607L130.321 24.7607L80.6308 85.5809ZM114.905 1.03542L130.443 23.5529L98.0172 23.5529L114.905 1.03542ZM96.8177 23.1394L80.4807 0.605617L113.718 0.60562L96.8177 23.1394ZM79.2986 1.03286L95.6257 23.5529L63.0832 23.5529L79.2986 1.03286Z",
    stroke: "#F7F9FC",
    strokeWidth: 1.20776
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.31 34.3206C149.35 34.2104 149.506 34.2104 149.547 34.3206V34.3206C150.059 35.7053 151.151 36.7971 152.536 37.3096V37.3096C152.646 37.3503 152.646 37.506 152.536 37.5468V37.5468C151.151 38.0592 150.059 39.151 149.547 40.5358V40.5358C149.506 40.6459 149.35 40.6459 149.31 40.5358V40.5358C148.797 39.151 147.705 38.0592 146.321 37.5468V37.5468C146.21 37.506 146.21 37.3503 146.321 37.3096V37.3096C147.705 36.7971 148.797 35.7053 149.31 34.3206V34.3206Z",
    fill: "#EFAB0C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_617_31558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 34,
    width: 7,
    height: 7
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.31 34.3206C149.35 34.2104 149.506 34.2104 149.547 34.3206V34.3206C150.059 35.7053 151.151 36.7971 152.536 37.3096V37.3096C152.646 37.3503 152.646 37.506 152.536 37.5468V37.5468C151.151 38.0592 150.059 39.151 149.547 40.5358V40.5358C149.506 40.6459 149.35 40.6459 149.31 40.5358V40.5358C148.797 39.151 147.705 38.0592 146.321 37.5468V37.5468C146.21 37.506 146.21 37.3503 146.321 37.3096V37.3096C147.705 36.7971 148.797 35.7053 149.31 34.3206V34.3206Z",
    fill: "#FEE699"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_617_31558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.855 37.4312C151.713 37.4312 149.427 38.5739 149.427 40.8594L152.855 37.4312Z",
    fill: "#EFAB0C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_617_31558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 34,
    width: 7,
    height: 7
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M149.31 34.3206C149.35 34.2104 149.506 34.2104 149.547 34.3206V34.3206C150.059 35.7053 151.151 36.7971 152.536 37.3096V37.3096C152.646 37.3503 152.646 37.506 152.536 37.5468V37.5468C151.151 38.0592 150.059 39.151 149.547 40.5358V40.5358C149.506 40.6459 149.35 40.6459 149.31 40.5358V40.5358C148.797 39.151 147.705 38.0592 146.321 37.5468V37.5468C146.21 37.506 146.21 37.3503 146.321 37.3096V37.3096C147.705 36.7971 148.797 35.7053 149.31 34.3206V34.3206Z",
    fill: "#FEE699"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_617_31558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146 37.4282C147.143 37.4282 149.428 36.2854 149.428 34L146 37.4282Z",
    fill: "#EFAB0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.855 37.4282C151.713 37.4282 149.427 36.2854 149.427 34L152.855 37.4282Z",
    fill: "#EFAB0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 37.4312C147.143 37.4312 149.428 38.5739 149.428 40.8594L146 37.4312Z",
    fill: "#EFAB0C"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.619 41.6411C138.701 41.4209 139.012 41.4209 139.094 41.6411V41.6411C140.119 44.4107 142.302 46.5943 145.072 47.6191V47.6191C145.292 47.7006 145.292 48.0121 145.072 48.0936V48.0936C142.302 49.1184 140.119 51.302 139.094 54.0716V54.0716C139.012 54.2918 138.701 54.2918 138.619 54.0716V54.0716C137.595 51.302 135.411 49.1184 132.641 48.0936V48.0936C132.421 48.0121 132.421 47.7006 132.641 47.6191V47.6191C135.411 46.5943 137.595 44.4107 138.619 41.6411V41.6411Z",
    fill: "#EFAB0C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_617_31558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 41,
    width: 14,
    height: 14
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.619 41.6411C138.701 41.4209 139.012 41.4209 139.094 41.6411V41.6411C140.119 44.4107 142.302 46.5943 145.072 47.6191V47.6191C145.292 47.7006 145.292 48.0121 145.072 48.0936V48.0936C142.302 49.1184 140.119 51.302 139.094 54.0716V54.0716C139.012 54.2918 138.701 54.2918 138.619 54.0716V54.0716C137.595 51.302 135.411 49.1184 132.641 48.0936V48.0936C132.421 48.0121 132.421 47.7006 132.641 47.6191V47.6191C135.411 46.5943 137.595 44.4107 138.619 41.6411V41.6411Z",
    fill: "#FEE699"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_617_31558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.715 47.8546C143.43 47.8546 138.859 50.14 138.859 54.7109L145.715 47.8546Z",
    fill: "#EFAB0C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_617_31558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 41,
    width: 14,
    height: 14
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M138.619 41.6411C138.701 41.4209 139.012 41.4209 139.094 41.6411V41.6411C140.118 44.4107 142.302 46.5943 145.072 47.6191V47.6191C145.292 47.7006 145.292 48.0121 145.072 48.0936V48.0936C142.302 49.1184 140.118 51.302 139.094 54.0716V54.0716C139.012 54.2918 138.701 54.2918 138.619 54.0716V54.0716C137.594 51.302 135.411 49.1184 132.641 48.0936V48.0936C132.421 48.0121 132.421 47.7006 132.641 47.6191V47.6191C135.411 46.5943 137.594 44.4107 138.619 41.6411V41.6411Z",
    fill: "#FEE699"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_617_31558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132 47.8563C134.285 47.8563 138.856 45.5709 138.856 41L132 47.8563Z",
    fill: "#EFAB0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.715 47.8563C143.429 47.8563 138.859 45.5709 138.859 41L145.715 47.8563Z",
    fill: "#EFAB0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 47.8546C134.285 47.8546 138.856 50.14 138.856 54.7109L132 47.8546Z",
    fill: "#EFAB0C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_617_31558",
    x: 8,
    y: 37,
    width: 146,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.137255 0 0 0 0 0.243137 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_617_31558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_617_31558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_617_31558",
    x: 14.999,
    y: -10,
    width: 128.595,
    height: 112.168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.137255 0 0 0 0 0.243137 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_617_31558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_617_31558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_617_31558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 145,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.188aed0864f71ea04abedf3ffc4f749a.svg";
export { ForwardRef as ReactComponent };